'use strict';

(function () {
  'use strict';

  angular.module('msCore').service('agreementsSvc', agreementsSvc);

  agreementsSvc.$inject = ['httpSvc', '$q', 'msAuth', '$sessionStorage'];

  function agreementsSvc(httpSvc, $q, msAuth, $sessionStorage) {
    function getAgreementsByCode(language, accessCode, force) {
      if ($sessionStorage.agreements && !force) {
        return $q.when($sessionStorage.agreements);
      }

      return httpSvc.get('/apiproxy/user/agreements/byCode' + ('?language=' + language + (accessCode ? '&accessCode=' + accessCode : '')), {
        withCredentials: msAuth.isLoggedIn()
      }).then(function (agreements) {
        $sessionStorage.agreements = agreements;
        return $sessionStorage.agreements;
      });
    }

    function getAgreements() {
      return httpSvc.get('/apiproxy/user/agreements');
    }

    function saveAgreements(agreements) {
      return httpSvc.post('/apiproxy/user/agreements', agreements);
    }

    return {
      getAgreements: getAgreements,
      saveAgreements: saveAgreements,
      getAgreementsByCode: getAgreementsByCode
    };
  }
})();